// extracted by mini-css-extract-plugin
export var contentBody = "_95-9";
export var headerImage = "_95-2";
export var imageButton = "_95-7";
export var imageButtonIcon = "_95-8";
export var imageHeader = "_95-4";
export var imageHeaderText = "_95-5";
export var imageOverlay = "_95-3";
export var imageTitle = "_95-6";
export var imageWrapper = "_95-1";
export var taskList = "_95-a";
export var widget = "_95-0";